<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import store from '../../../store';
import SkiSchoolLevel from '../../../components/ski/school/SkiSchoolLevel';
import i18n from '../../../i18n';

export default {
  name: 'SkiSchoolLevels',
  components: {
    SkiSchoolLevel,
  },
  computed: {
    ...mapGetters({
      levels: 'skischool/getLevels',
    }),
    ...mapState({
      season: state => state.skischool.season,
      levelsLoading: state => state.skischool.season.levels.itemsLoading,
      levelsError: state => state.skischool.season.levels.itemsError,
      levelSaveLoading: state => state.skischool.season.levels.saveLoading,
      levelSaveError: state => state.skischool.season.levels.saveError,
    }),
    isNewLevelActive() {
      return this.levels.some(level => level.id === undefined);
    },
    errorOccurred() {
      return this.levelsError || this.levelSaveError;
    },
  },
  methods: {
    ...mapActions({
      loadLevels: 'skischool/levelsByIdLoad',
      addNewLevel: 'skischool/levelAddNew',
      createLevel: 'skischool/levelCreate',
      saveLevel: 'skischool/levelSave',
      removeLevel: 'skischool/levelRemove',
      setLevel: 'skischool/setLevel',
    }),
    createOrUpdate(level) {
      if (level.id) {
        this.saveLevel(level);
      } else {
        this.createLevel(level);
      }
    },
    remove(levelId) {
      // eslint-disable-next-line no-alert
      if (!levelId || confirm(i18n.t('ski.skiLevel.removeAreYouSure'))) {
        this.removeLevel(levelId);
      }
    },
    onLevelChange(payload) {
      this.setLevel(payload);
    },
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.seasonId) {
      store.dispatch('skischool/levelsByIdLoad', to.params.seasonId)
        .finally(() => {
          next();
        });
    }
  },
};
</script>
<template>
  <v-container class="pa-0">
    <div>
      <h2 class="d-inline-block">
        {{ $t('ski.skiLevels.title') }}
        ({{ Object.keys(this.levels).length }})
      </h2>
      <v-btn
        @click="this.addNewLevel"
        :disabled="isNewLevelActive
          || this.levelsLoading
          || this.levelSaveLoading
        "
        class="mb-2"
        color="success"
        outline
      >
        {{ $t('ski.skiLevels.new') }}
      </v-btn>
      <v-btn
        @click="loadLevels(season.id)"
        :loading="levelsLoading"
        icon
      >
        <v-icon>cached</v-icon>
      </v-btn>
    </div>
    <div class="text-center">
      <v-progress-linear
        v-if="this.levelsLoading || this.levelSaveLoading"
        :indeterminate="true"
      />
    </div>
    <v-alert
      :value="this.errorOccurred"
      color="error"
      icon="warning"
      outline
    >
      <span v-html="errorOccurred"></span>
    </v-alert>
    <v-layout v-if="levels.length" wrap>
      <v-flex sm2 xs12 offset-sm1>
        <p class="font-weight-bold pl-2 pt-2">{{ $t('ski.skiLevel.nameSupplier') }}</p>
      </v-flex>
      <v-flex sm2 xs12>
        <p class="font-weight-bold pl-2 pt-2">{{ $t('ski.skiLevel.nameWebsite') }}</p>
      </v-flex>
      <v-flex sm1 xs12>
        <p class="font-weight-bold pl-2 pt-2">{{ $t('ski.skiLevel.priority') }}</p>
      </v-flex>
      <v-flex sm2 xs12>
      </v-flex>
    </v-layout>
    <v-layout
      v-for="(level) in levels"
      :key="'ski-level-' + level.id"
      :loading="levelsLoading"
      xs12
    >
      <ski-school-level
        @onLevelChange="onLevelChange"
        @createOrUpdate="createOrUpdate"
        @remove="remove"
        :level="level"
        :save-loading="levelSaveLoading"
      />
    </v-layout>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/pages/ski/school/SkiSchoolSeasonLevels.vue